<template>
  <div class="onboarding-signature-contract-view">
    <StepInfoHeader :showHeaderHelperIcon="showHeaderHelperIcon" />

    <div class="iframe_scope">
      <iframe class="iframe" :src="ccbUrl"></iframe>
    </div>

    <div class="footer">
      <Button class="primary" @click="handleClick">
        <span>Assinar contrato</span>
      </Button>
    </div>
  </div>
</template>

<script>
import StepInfoHeader from '../../feature/onboarding/components/StepInfoHeader.vue';

export default {
  name: 'signature-contract-view',
  components: {
    StepInfoHeader,
  },
  props: {
    ccbUrl: {
      type: String,
      required: true,
    },
    showHeaderHelperIcon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-signature-contract-view {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-width: 100%;
  height: calc(100vh - 10px);
  height: 100dvh;
  min-height: 100%;
}

.header {
  padding-left: 1.5rem;
  padding-right: 1.5rem;

  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.iframe_scope {

  flex-grow: 1;

  height: 100%;

  overflow: auto;
}

.iframe {
  width: 100%;
  height: 100%;
  display: block;
}

.footer {
  background-color: white;
  padding: 20px 24px;

  button {
    width: 100%;
    height: 100%;
    padding: 0.3rem 0;
  }
}
</style>
